export const version = "1.7.21";
export const channel = "release";
export const gitcommit = "unknown";
